import { Language } from '@gig/magic-sdk/dist/adapter/users/language';
import { config as sitemapConfig } from '../../../scripts/sitemap/sitemap-config';
import { formatLangV2 } from '../../../scripts/util/language';

// Set HTML lang
export function setHtmlLang(lang: Language) {
    const getHTMLTag = document.documentElement;
    getHTMLTag.setAttribute('lang', formatLang(lang));
}

/**
 * to get HTML lang format
 * for cf it return fr-ca
 * The first part “fr” is for French language and the second one, “ca”, is for target country.
 * in case that no country y set it will return the current language
 */
export function formatLang(lang: string): string {
    // code commented to avoid build errors
    //const { xDefault, marketToLanguage, marketToCountry } = sitemapConfig;
    const { xDefault, marketToCountry } = sitemapConfig;
    const country = marketToCountry[lang];
    //const language = marketToLanguage[lang];

    if (lang === xDefault) {
        return xDefault;
    } else {
        // hardcoded until we can find a better approach to handle this formatLang
        // if we change the values in marketToLanguage in the sitemap config, then the sitemap will not be generated
        return formatLangV2(country, Language.ENGLISH);
    }
}
